import { post } from '../http';

const sendMessage = async (data) => {
  return post('/api/message', data);
};

const MessageController = { sendMessage };

export default MessageController;
